// `extension-preferences-tooltip.tpl.html` — the panel the header menu's Settings item opens.
//
// ⚠️ IT IS AN ELEMENT SELECTOR, NOT A CLASS. `_shortlist-header.scss` positions
// `extension-preferences-tooltip` — the component ELEMENT — absolutely inside
// `.shortlist-header-actions-dropdown-container`, and the class of the same name inside it
// carries the width, padding and shadow. A `<div className="extension-preferences-tooltip">`
// matches the second rule and not the first, so the panel would render in the flow and push
// the header down. (The trap CLAUDE.md records for six other components.)
import { createElement, type ReactElement } from 'react'
import type { ExtensionPreferences } from '@woo-ext/api'
import { ExtensionPreferencesForm } from './ExtensionPreferencesForm.tsx'

export interface ExtensionPreferencesTooltipProps {
  preferences: ExtensionPreferences
  atsLabel?: string
  indeedSearchEnabled?: boolean
  onChange?: (preferences: ExtensionPreferences) => void
}

export function ExtensionPreferencesTooltip({
  preferences,
  atsLabel,
  indeedSearchEnabled,
  onChange,
}: ExtensionPreferencesTooltipProps): ReactElement {
  return createElement(
    'extension-preferences-tooltip',
    null,
    <div className="extension-preferences-tooltip">
      <div className="extension-preferences-tooltip-header">
        <span>Automatically present Woo screen</span>
      </div>
      <div className="extension-preferences-tooltip-body">
        <ExtensionPreferencesForm
          preferences={preferences}
          {...(atsLabel === undefined ? {} : { atsLabel })}
          {...(indeedSearchEnabled === undefined ? {} : { indeedSearchEnabled })}
          {...(onChange === undefined ? {} : { onChange })}
        />
      </div>
    </div>,
  )
}
